<template>
  <div class="map-wrapper" :class="{'large':large}">

    <map-featured-component
      v-show="content"
      :content="content"
      @close="emptyContent"
    ></map-featured-component>
    <div class="map-filters">
      <h2 v-html="translations.find"></h2>
      <div class="map-select">
        <div class="label-div">
          <label for="country" v-html="translations.where"></label>
        </div>
        <div class="select-wrapper">
          <select name="country" v-model="selectedCountry">
            <option value="all" v-html="translations.all_countries"></option>
            <option v-for="country in sortedCountries" :value="country" v-html="country"></option>
          </select>
        </div>
      </div>
      <div class="map-checkboxes">
        <div class="label-div">
          <label v-html="translations.what"></label>
        </div>
        <div class="checkboxes" v-for="type in sortedTypes">
          <input type="checkbox" :id="type.id" v-model="selectedTypes" :value="type.id" style="display:none;">
          <label :for="type.id"><i class="icon" :class="iconClass(type.id)"></i><span v-html="type.name"></span>
            <div class="type-image"><img class="taxonomy-svg" :src="'/images/svg/'+ type.svg +'.svg'"></div>
          </label>
        </div>
      </div>
      <div class="map-select">
        <div class="label-div">
          <label for="month" v-html="translations.when"></label>
        </div>
        <div class="select-wrapper">
          <select name="month" v-model="selectedMonth">
            <option value="all" v-html="translations.matter"></option>
            <option v-for="month, index in months" :value="index" v-html="month"></option>
          </select>
        </div>
      </div>
    </div>

    <div id="map"></div>

  </div>
</template>

<script>

import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import {MapboxStyleSwitcherControl} from "mapbox-gl-style-switcher";
import "mapbox-gl-style-switcher/styles.css";
import axios from 'axios';
import MapFeaturedComponent from "./MapFeaturedComponent"
import MapboxglSpiderifier from "mapboxgl-spiderifier";
import "mapboxgl-spiderifier/index.css";

import {bbox, featureCollection} from '@turf/turf';

mapboxgl.accessToken = 'pk.eyJ1IjoiYnJhbXdlYm9udHdpa2tlbGluZyIsImEiOiJja3A4NTM5dDYwMHZoMnJsbHI4cHBmY3NhIn0.ugOl1ynyEt6S3RWZC6m7uw';

export default {
  name: "MapComponent",
  props: {
    'selected_tab': undefined,
    'large': false,
    'translations': {
      required: true
    }
  },
  data: function () {
    return {
      map: undefined,
      geojson: undefined,
      image: undefined,
      spiderifier: undefined,
      typeIndex: drupalSettings.ibo.types,
      months: drupalSettings.ibo.months,
      types: [],
      selectedTypes: [],
      countries: [],
      // months: [],
      selectedCountry: 'all',
      selectedMonth: 'all',
      content: "",
      clicked: false,
      tabletWidth: 780,
      maxzoom:8
    }
  },
  components: {
    'map-featured-component': MapFeaturedComponent
  },
  watch: {
    selected_tab() {
      if (typeof this.map !== 'undefined') {
        this.map.resize();
      }
    },
    selectedTypes() {
      if (this.map.getSource('points')) {
        this.applyFilters();
      }
    },
    selectedCountry() {
      if (this.map.getSource('points')) {
        this.applyFilters();
      }
    },
    selectedMonth() {
      if (this.map.getSource('points')) {
        this.applyFilters();
      }
    },
  },
  computed: {
    sortedCountries() {
      return this.countries.sort();
    },
    sortedTypes() {
      let types = []
      for (let i = 0; i < this.typeIndex.length; i++) {
        if (this.types.indexOf(this.typeIndex[i].id) != -1) {
          types.push(this.typeIndex[i])
        }
      }
      return types;
    },
    // processedMonths() {
    //   let months = this.months;
    //   for (let i=0; i < months.length; i++) {
    //     if(months[i] == 'all') {
    //       months[i] = this.translations.date_in_consultation;
    //     }
    //   }
    //   return months;
    // }
  },
  methods: {
    // typeName(index) {
    //   let type = this.typeIndex[index];
    //   return type.name;
    // },
    // typeSVG(index) {
    //   let type = this.typeIndex[index];
    //   return type.svg;
    // },
    iconClass(type) {
      if (this.selectedTypes.indexOf(type) == -1) {
        return 'icon-checkbox-unchecked'
      }
      return 'icon-checkbox-checked'
    },
    processFeatures() {

      let features = this.geojson.features;
      for (let i = 0; i < features.length; i++) {
//collect unique countries in use
        let country = features[i].properties.country;
        if (this.countries.indexOf(country) == -1) {
          this.countries.push(country);
        }

//collect unique months in use
//         let month = features[i].properties.month;

        // if(this.months.indexOf(month) == -1) {
        //   this.months.push(month);
        // }

//collect unique types in use
        let types = features[i].properties.type.split(",");
        for (let j = 0; j < types.length; j++) {
          if (this.types.indexOf(types[j]) == -1) {
            this.types.push(types[j]);
          }
        }
        this.selectedTypes = this.types;
      }
    },
    initMap() {

      let component = this;
      let map = new mapboxgl.Map({
        container: 'map', // container id
        style: 'mapbox://styles/mapbox/streets-v11', // style URL
        maxZoom:this.maxzoom,
      });

      component.spiderifier = new MapboxglSpiderifier(map, {
        onClick: function(e, spiderLeg){
          component.setFeaturedContent(spiderLeg.feature.description);
        },
        customPin: true,
        circleFootSeparation:60,
        initializeLeg: function(spiderLeg) {
          var img = document.createElement('img');
          img.src="/images/marker.png";
          var div = document.createElement('div');
          div.style.width="27px"
          div.style.height="35px"
          div.style.position="relative";
          div.style.left="-13.5px"
          div.style.top="-17.5px"
          div.appendChild(img);

          spiderLeg.elements.pin.append(div);

          spiderLeg.elements.container.addEventListener("click", function() {

          });

          if (!component.isTouchDevice()) {

            spiderLeg.elements.container.addEventListener("mouseover", function () {
              if (!component.clicked) {
                component.setFeaturedContent(spiderLeg.feature.description, false);
              }
            });

            spiderLeg.elements.container.addEventListener("mouseout", function () {
              if (!component.clicked) {
                component.emptyContent();
              }
            });
          }
        }
      });






      this.map = map;

      // disable map rotation using right click + drag
      map.dragRotate.disable();
      map.scrollZoom.disable();

      const isTouchEvent = e => e.originalEvent && "touches" in e.originalEvent;
      const isTwoFingerTouch = e => e.originalEvent.touches.length >= 2;

      map.on("dragstart", event => {
        if (isTouchEvent(event) && !isTwoFingerTouch(event)) {
          map.dragPan.disable();
        }
      });

      // Drag events not emited after dragPan disabled, so I use touch event here
      map.on("touchstart", event => {
        if (isTouchEvent(event) && isTwoFingerTouch(event)) {
          map.dragPan.enable();
        }
      });


// disable map rotation using touch rotation gesture
      map.touchZoomRotate.disableRotation();

      map.addControl(new mapboxgl.FullscreenControl({container: document.querySelector('.map-wrapper')}), 'top-right');
      map.addControl(new mapboxgl.NavigationControl({showCompass: false}), 'top-right');


      let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
      let paddingLeft = (width > this.tabletWidth) ? 300 : 20;
      let padding = (width > this.tabletWidth) ? 40 : 20;


      map.fitBounds(bbox(component.geojson), {
        animate: false,
        padding: {top: padding, bottom: padding, left: paddingLeft, right: padding}
      });


      map.addControl(new MapboxStyleSwitcherControl([
        {
          title: "Streets",
          uri: "mapbox://styles/mapbox/streets-v11"
        },
        {
          title: "Mapbox Outdoor",
          uri: "mapbox://styles/mapbox/outdoors-v11"
        },
        {
          title: "Satelliet",
          uri: "mapbox://styles/mapbox/satellite-v9"
        }

      ]));


      map.on('load', function () {
        map.loadImage(
          '/images/ibomarker.png',
          function (error, image) {
            if (error) {
              throw error;
            }
            component.image = image;
            component.setMapStyle();

            map.on('style.load', function () {


              component.setMapStyle();
              component.applyFilters(false);
            });


          });
      });
// }

    },
    setMapStyle() {
      let component = this;
      let map = this.map;
      map.addImage('custom-marker', component.image);
      map.addSource('points', {
        'type': 'geojson',
        'data': component.geojson,
        'cluster': true,
        'clusterMaxZoom': 18, // Max zoom to cluster points on
        'clusterRadius': 20 // Radius of each cluster when clustering points (defaults to 50)
      });

      map.addLayer({
        id: 'clusters',
        type: 'circle',
        source: 'points',
        filter: ['has', 'point_count'],
        layout: {
        },
        paint: {
// Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
// with three steps to implement three types of circles:
//   * Blue, 20px circles when point count is less than 100
//   * Yellow, 30px circles when point count is between 100 and 750
//   * Pink, 40px circles when point count is greater than or equal to 750
          'circle-color': '#cc2229',
          'circle-radius': [
            'step',
            ['get', 'point_count'],
            20,
            100,
            30,
            750,
            40
          ]
        }
      });

      map.addLayer({
        id: 'cluster-count',
        type: 'symbol',
        source: 'points',
        filter: ['has', 'point_count'],
        layout: {
          'text-field': '{point_count_abbreviated}',
          'text-font': ["Arial Unicode MS Bold"],
          'text-size': 14,
          'text-allow-overlap': true,
        },
        "paint": {
          'text-color': 'white'
        }
      });

      map.addLayer({
        'id': 'projects',
        'type': 'symbol',
        'source': 'points',
        'filter': ['!', ['has', 'point_count']],
        'layout': {
          'icon-image': 'custom-marker',
          'icon-size': 0.5,
          'icon-anchor':'bottom'
        }
      });

// When a click event occurs on a feature in the places layer, open a popup at the
// location of the feature, with description HTML from its properties.
      map.on('click', 'projects', function (e) {
        component.spiderifier.unspiderfy();
        component.setFeaturedContent(e.features[0].properties.description);
      });



      if (!this.isTouchDevice()) {

        map.on('mousemove', 'projects', function (e) {
          if (e.features.length > 0) {
            if (!component.clicked) {
              component.setFeaturedContent(e.features[0].properties.description, false);
            }
          }
        });

        map.on('mouseleave', 'projects', function () {
          if (!component.clicked) {
            component.emptyContent();
          }
        });

      }


      map.on('click', 'clusters', function (e) {





        var features = map.queryRenderedFeatures(e.point, {
          layers: ['clusters']
        });
        var clusterId = features[0].properties.cluster_id;
        map.getSource('points').getClusterExpansionZoom(
          clusterId,
          function (err, zoom) {
            if (err) {
              return;
            }


            if (map.getZoom() >= component.maxzoom) {
              component.spider(e);
            }
            else {
              map.easeTo({
                duration: 1000,
                center: features[0].geometry.coordinates,
                zoom: (zoom < component.maxzoom) ? zoom : component.maxzoom
              });
            }

          }
        );
      });


    },
    emptyContent() {
      this.setFeaturedContent('');
      this.clicked = false;
    },
    spider(e) {
      let component = this;
      let map = this.map;
      let features = map.queryRenderedFeatures(e.point, {
        layers: ['clusters']
      });

      this.spiderifier.unspiderfy();
      if (!features.length) {
        return;
      } else {

        map.getSource('points').getClusterLeaves(
          features[0].properties.cluster_id,
          100,
          0,
          function(err, leafFeatures){
            if (err) {
              return console.error('error while getting leaves of a cluster', err);
            }
            // let markers = map(leafFeatures, function(leafFeature){
            //   return leafFeature.properties;
            // });
            let markers = leafFeatures.map(leafFeature => leafFeature.properties);

            component.spiderifier.spiderfy(features[0].geometry.coordinates, markers);
          }
        );
      }
    },
    applyFilters(zoom = true) {
      this.emptyContent();

      let features = [];
      for (let i = 0; i < this.geojson.features.length; i++) {
        let feature = this.geojson.features[i];
        if (this.featureIsAllowedByFilters(feature)) {
          features.push(feature);
        }
      }

      let geojson = new featureCollection(features)

      this.map.getSource('points').setData(geojson);

      if (zoom) {
        if (features.length) {
          this.map.fitBounds(bbox(geojson), {
            padding: {top: 40, bottom: 40, left: 300, right: 40},
            maxZoom: 6
          });
        }
        else {
          this.map.fitBounds(bbox(this.geojson), {
            padding: {top: 40, bottom: 40, left: 300, right: 40}
          });
        }
      }


      // this.map.setFilter('projects',
      //   [
      //     "all",
      //     this.getTypeFilters(),
      //     this.getCountryFilter(),
      //     this.getMonthFilter()
      //   ]
      // );
    },
    featureIsAllowedByFilters(feature) {
      return this.typeIsIncluded(feature) && this.countryIsIncluded(feature) && this.monthIsIncluded(feature)
    },
    typeIsIncluded(feature) {
      for (let i = 0; i < this.selectedTypes.length; i++) {

        let types = feature.properties.type.split(",");

        if (types.includes(this.selectedTypes[i])) {
          return true;
        }
      }
    },
    countryIsIncluded(feature) {
      if (this.selectedCountry === 'all') {
        return true
      }
      if (feature.properties.country == this.selectedCountry) {
        return true
      }
    },
    monthIsIncluded(feature) {
      if (this.selectedMonth === 'all') {
        return true
      }
      if (feature.properties.month == 'all') {
        return true
      }
      if (feature.properties.month == this.selectedMonth) {
        return true
      }
    },
    // getTypeFilters() {
    //   let typeFilters = ["any"];
    //   for(let i = 0; i < this.selectedTypes.length; i++) {
    //     typeFilters.push(["in", this.selectedTypes[i], ["get", "type"]])
    //   }
    //   return typeFilters;
    // },
    // getCountryFilter() {
    //   if (this.selectedCountry !== 'all') {
    //     return ["==", this.selectedCountry, ["get", "country"]];
    //   }
    //   return true
    // },
    // getMonthFilter() {
    //   if (this.selectedMonth !== 'all') {
    //     return ["==", this.selectedMonth, ["get", "month"]];
    //   }
    //   return true
    // },
    setFeaturedContent(content, clicked = true) {
      this.content = content;
      this.clicked = clicked;
    },
    isTouchDevice() {
      return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
    }
  },
  mounted() {
    let component = this;

    let url;
    if (drupalSettings.ibo.lang == 'nl') {
      url = '/feed/projects.geojson';
    }
    else {
      url = '/' + drupalSettings.ibo.lang + '/feed/projects.geojson';
    }
    axios.get(url)
      .then(function (response) {
        component.geojson = response.data;
        component.processFeatures();
        component.initMap();
      })
      .catch(function (error) {
        console.log(error);
      })
      .then(function () {
// always executed
      });

  }
}
</script>



